// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pwiC","tabsBox":"styles_tabsBox__1tkNL","createButton":"styles_createButton__3TFLE"};